// extracted by mini-css-extract-plugin
module.exports = {"singleLineAddressWrapper":"RD","addressContent":"SD","forceWrap":"TD"};